import {gql} from "apollo-angular";


export const LOGIN_QUERY = gql`
  query Login($input: LoginInput!) {
    login(input: $input) {
      auth {
        auth {
          token
          refreshToken
        }
        user {
          id
          firstName
          lastName
          email
          role
        }
        staffRole {
          name
          permissions
        }
      }
      otp
      message
    }
  }
`;

export const REFRESH_TOKEN_QUERY = gql`
  query RefreshToken($input: RefreshPayload!) {
    refreshToken(input: $input)
  }
`;

export const ME_QUERY = gql`
    query Me{
      me {
        user{
          id
           alternateMobileNumber
      address
      country
      state
      postalCode
      city
          organisationusers{
          organisationID
          id
          organisation{
          deviceLimit
          }
          }
          firstName
          lastName
          email
          mobileNumber
          role
          avatarID
        
        }
        staffRole {
          name
          permissions
        }
      }
    }
`
export const WHITELABEL_FOR_USER = gql`
    query getWhitelabelOrgsForUser($input: GetWhitelabelOrgsForUserInput!) {
      getWhitelabelOrgsForUser(input: $input) {
        whitelabel {
          id
          brandName
          organisation {
            id
            name
          }
          enabledLoginMethods
        }
        config {
          key
          value
        }
        overrideConfig {
          key
          value
        }
      }
    }
`
//OTP Query
export const SEND_OTP_QUERY = gql`
  query SendOtp($input: LoginInput!) {
    login(input: $input) {
      otp
      message
    }
  }
`;

